export default __webpack_public_path__ + "static/media/large-crumb2-play.fa582b2c.png";